// extracted by mini-css-extract-plugin
module.exports = {"header":"UnitDetails_header__2dP30"};